import { useRealtimeResume } from './store';
import styles from './ConnectionBanner.module.css';
import type { ConnectionNotice } from './use-connection-notice';

/**
 * Faixa no topo da caixa de entrada quando o tempo real não está funcionando. A região de status
 * existe sempre (vazia quando está tudo bem): leitores de tela só anunciam texto que APARECE nela.
 */
export function ConnectionBanner({ notice }: { notice: ConnectionNotice }) {
  const resume = useRealtimeResume();
  return (
    <div role="status" className={notice ? styles.banner : styles.hidden} data-notice={notice}>
      {notice === 'reconnecting' && (
        <p className={styles.text}>
          Sem conexão em tempo real. Tentando reconectar… As mensagens novas podem demorar a
          aparecer.
        </p>
      )}
      {notice === 'paused' && (
        <>
          <p className={styles.text}>
            A caixa de entrada foi aberta em outra janela, e esta parou de receber mensagens novas.
          </p>
          <button type="button" className={styles.button} onClick={resume}>
            Usar esta janela
          </button>
        </>
      )}
    </div>
  );
}
